import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const WalletIcon = (props) => (
  <svg viewBox="0 0 20 20" fill="none" {...props}>
    <path d="M7.4375 4.58826C7.0578 4.58826 6.75 4.94003 6.75 5.37397C6.75 5.80791 7.0578 6.15969 7.4375 6.15969H11.5625C11.9422 6.15969 12.25 5.80791 12.25 5.37397C12.25 4.94003 11.9422 4.58826 11.5625 4.58826H7.4375Z" fill="currentColor"/>
    <path d="M5.375 7.73111C5.375 7.29718 5.6828 6.9454 6.0625 6.9454H12.9375C13.3172 6.9454 13.625 7.29718 13.625 7.73111C13.625 8.16505 13.3172 8.51683 12.9375 8.51683H6.0625C5.6828 8.51683 5.375 8.16505 5.375 7.73111Z" fill="currentColor"/>
    <path d="M4 10.874C4 10.0061 4.61561 9.30254 5.375 9.30254H13.625C14.3844 9.30254 15 10.0061 15 10.874V14.0168C15 14.8847 14.3844 15.5883 13.625 15.5883H5.375C4.61561 15.5883 4 14.8847 4 14.0168V10.874Z" fill="currentColor"/>
    <path d="M9.70588 0.588257C4.33529 0.588257 0 4.92355 0 10.2941C0 15.6647 4.33529 20 9.70588 20C15.0765 20 19.4118 15.6647 19.4118 10.2941C19.4118 4.92355 15.0765 0.588257 9.70588 0.588257ZM9.70588 18.7059C5.04706 18.7059 1.29412 14.953 1.29412 10.2941C1.29412 5.63532 5.04706 1.88237 9.70588 1.88237C14.3647 1.88237 18.1176 5.63532 18.1176 10.2941C18.1176 14.953 14.3647 18.7059 9.70588 18.7059Z" fill="currentColor"/>
  </svg>
);

const FichaCertaSection = ({ data }) => {
  const { sintese, locacao } = data;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <WalletIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="fichaCerta" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        {locacao.parecer_inquilinos?.score_conjunto && (
          <div className="w-1/2 mb-[1vw]">
            <div className="font-bold">Parecer Inquilinos</div>
            <span data-cy="order-details-parecer-inquilinos">{locacao.parecer_inquilinos?.score_conjunto}</span>
          </div>
        )}
        {locacao.parecer_fiadores?.score_conjunto && (
          <div className="w-1/2 mb-[1vw]">
            <div className="font-bold">Parecer Fiadores</div>
            <span data-cy="order-details-parecer-fiadores">{locacao.parecer_fiadores?.score_conjunto}</span>
          </div>
        )}
        {locacao.risco && (
          <div className="w-1/2 mb-[1vw]">
            <div className="font-bold">Risco</div>
            <span data-cy="order-details-risco">{locacao.risco}</span>
          </div>
        )}
      </div>

      {sintese && (
        <div className="mt-[2vw] text-[#858585] pl-[calc(14px+1.8vw)]">
          <div className="font-bold text-[calc(6px+0.4vw)] mb-[0.8vw]">Pretendentes</div>
          
          <div className="flex justify-between w-full mb-[0.5vw] text-[calc(5px+0.4vw)] font-bold">
            <div className="w-[40%]">
              <FormattedMessage id="name" />
            </div>
            <div className="w-[40%]">
              <FormattedMessage id="type" />
            </div>
            <div className="w-[20%]">
              <FormattedMessage id="cnpj_or_cpf" />
            </div>
          </div>

          {sintese?.map((suitor, idx) => (
            <React.Fragment key={suitor.cpf || suitor.cnpj || idx}>
              <div className="relative flex justify-between w-full text-[calc(5px+0.35vw)] py-[0.4vw] border-t border-[#F0F0F0]">
                <div className="w-[40%] font-semibold">
                  {suitor.nome}
                </div>
                <div className="w-[40%]">
                  <FormattedMessage id={suitor.tipo_pretendente} />
                </div>
                <div className="w-[20%]">{suitor.cpf || suitor.cnpj}</div>
              </div>

              <div className="pl-[1vw]">
                {suitor.parecer?.map((opinion, opIdx) => (
                  <div 
                    key={opinion.parecer_key || opIdx} 
                    className="flex items-center gap-[0.8vw] py-[0.2vw] text-[calc(5px+0.35vw)] relative pl-[1.5vw] before:content-[''] before:absolute before:left-0 before:top-[-50%] before:bottom-[50%] before:w-[1vw] before:border-l before:border-b before:border-dotted before:border-[#858585]"
                  >
                    <div title={opinion.recomendacao?.join(' ')}>
                      {opinion.risco}
                    </div>
                  </div>
                ))}
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

FichaCertaSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default FichaCertaSection;
